import React from 'react';

import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

interface BadgeProps {
  type: string;
  label?: string;
}

const useStyles = makeStyles({
  badge: {
    fontSize: 13,
    fontWeight: 500,
    padding: '2px 8px',
    borderRadius: 99,
    display: 'inline-block',
    border: '1px solid transparent',
  },
});

const badgeColors: Record<
  string,
  { bg: string; color: string; border: string }
> = {
  default: { bg: '#ffffff', color: '#444441', border: '#D1CFC9' },
  git: { bg: '#E6F1FB', color: '#0C447C', border: '#A9D0F5' },
  helm: { bg: '#EEEDFE', color: '#3C3489', border: '#C9B8F5' },
  internal: { bg: '#EAF3DE', color: '#27500A', border: '#B7D7A8' },
  external: { bg: '#f3f0de', color: '#503d0a', border: '#d7d6a8' },
  namespace: { bg: '#DAF7ED', color: '#085041', border: '#5DCAA5' },
  slack: { bg: '#bce4fe', color: '#084650', border: '#5d97ca' },
  grafana: { bg: '#fae8a6', color: '#8e650c', border: '#dfc022' },
  github: { bg: '#EDEDF1', color: '#24292F', border: '#C6C6D0' },
  enabled: { bg: '#EAF3DE', color: '#27500A', border: '#B7D7A8' },
  disabled: { bg: '#F1EFE8', color: '#444441', border: '#D1CFC9' },
};

export const Badge = ({ type, label }: BadgeProps) => {
  const classes = useStyles();
  const colors = badgeColors[type] || badgeColors.default;
  return (
    <Typography
      component="span"
      className={classes.badge}
      style={{
        background: colors.bg,
        color: colors.color,
        borderColor: colors.border,
      }}
    >
      {label || type}
    </Typography>
  );
};
